export default {
   mobile: '@media screen and (max-width: 599px)',
   mobileLandscapeAll: '@media screen and (max-width: 840px)',
   tablet: '@media screen and (min-width: 600px) and (max-width: 1000px)',
};
